import Page, { getServerSideProps as compGetServerSideProps } from 'components/pages/Courses';

export const getServerSideProps = compGetServerSideProps;
export default Page;
